import React from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';

const AllocatedAmount = (props) => {
    const { disabled, index, expense, isViewOnly } = props;
    const { control, errors } = useFormContext();

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].allocatedAmount`}
                defaultValue={expense?.allocatedAmount ?? ''}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required
                        placeholder="0.00"
                        id="allocated-amount"
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label="Allocated Amount"
                        endAdornment={
                            <AmountCurrencyInputAdornment
                                disabled={disabled || isViewOnly}
                                index={index}
                                currencyType={expense?.currency}
                                name={`expenseEntries[${index}].paymentCurrency`}
                            />
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.allocatedAmount)}
                        disabled={isViewOnly}
                        helperText={errors.expenseEntries?.[index]?.allocatedAmount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default AllocatedAmount;
